import { render, staticRenderFns } from "./detail-no-pharmacy.vue?vue&type=template&id=7d5cf9ed&"
import script from "./detail-no-pharmacy.vue?vue&type=script&lang=js&"
export * from "./detail-no-pharmacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports